<div fxLayout="column" fxFlexFill *samwebVar="directoryEditInfo$ | async; let dirInfo">
   <div style="height: 100%; overflow: auto; margin-bottom: 0.5em; margin-top: 0.5em">
      <div *ngFor="let editableColumn of editableColumns$ | async; let i = index">
         <samweb-directory-column-edit
            [column]="editableColumn"
            [icon]="editableColumn.columnTyp.columnIcon"
            [header]="editableColumn | directoryColumnTitle | async"
            [value]="editableColumn | directoryColumnValue: (directoryEditInfo$ | async).editedEntry | async"
            [valueOriginal]="editableColumn | directoryColumnValue: (directoryEditInfo$ | async).originalEntry | async"
            [valueUpdated]="editableColumn | directoryColumnValue: (directoryEditInfo$ | async).updatedEntry | async"
            [isComparatorActive]="editableColumn | directoryColumnComparator: directoryEditInfo$ | async"
            [isFocused]="i === 0"
            [isDisabled]="
               (editableColumn | directoryColumnIsRestricted: (directoryRestrictions$ | async)) ||
               (isEditEntry && !('DirectoryUpdateContact' | isFeatureEnabled$ | async))
            "
            [orgdata]="editableColumn | directoryColumnStructureData | async"
            [orgUnit]="editableColumn | directoryColumnOrganisationUnit"
            (valueChanged)="valueChanged($event, editableColumn)"
            (updateUnchangedValues)="updateUnchangedValues($event, editableColumn)"
            (takeMine)="takeMine($event, editableColumn)"
            (takeOther)="takeOther($event, editableColumn)"
         ></samweb-directory-column-edit>
      </div>
   </div>
   <!-- Bottom button bar -->
   <div class="sam-form-flex-row" style="width: 100%">
      <div
         kendoTooltip
         showOn="none"
         #deleteTooltipDirective="kendoTooltip"
         [tooltipTemplate]="deleteDialog"
         tooltipClass="tooltip-confirm-dialog"
      >
         <button
            #deleteButton
            *ngIf="isEditEntry && ('DirectoryDeleteContact' | isFeatureEnabled$ | async) && (isAttendant$ | async)"
            kendoButton
            (click)="onDelete()"
            primary="true"
         >
            <div class="sam-button-text">
               {{ 'common.delete' | translate }}
            </div>
         </button>

         <ng-template #deleteDialog>
            <div (samwebOutsideClick)="onDeleteCancel()">
               <samweb-confirm-dialog
                  [displayedText]="'common.confirmation.delete_entry' | translate"
                  (confirm)="onDeleteConfirm()"
                  (cancel)="onDeleteCancel()"
               ></samweb-confirm-dialog>
            </div>
         </ng-template>
      </div>

      <div
         fxFlex="1 1 auto"
         [ngClass]="
            !areEditableEntriesEqual
               ? 'sam-end sam-margin-right sam-opacity-light sam-warning sam-italic'
               : 'sam-end sam-margin-right sam-opacity-medium'
         "
      >
         <div *ngIf="isEditEntry">
            <div class="sam-margin-right sam-mini-font-size sam-end">
               {{ 'common.last-edited' | translate }}
            </div>
            <div class="sam-end sam-margin-right">
               {{ directoryEditInfo$ | async | directoryInfoLastEditingUser }} -
               {{ directoryEditInfo$ | async | directoryInfoLastTimeEdited | toMoment$ | async | amDateFormat: 'LL' }}
               {{ directoryEditInfo$ | async | directoryInfoLastTimeEdited | toMoment$ | async | amDateFormat: 'LTS' }}
            </div>
         </div>
      </div>

      <div class="sam-form-row sam-margin-left" style="float: right; margin-bottom: 0; align-self: flex-end">
         <button
            kendoButton
            (click)="onSave()"
            primary="true"
            [disabled]="!areEditableEntriesChanged || !(isAttendant$ | async)"
         >
            <div class="sam-button-text">
               {{ 'common.save' | translate }}
            </div>
         </button>
      </div>

      <div
         class="sam-form-row sam-margin-left"
         style="float: right; margin-bottom: 0; align-self: flex-end"
         kendoTooltip
         showOn="none"
         #closeTooltipDirective="kendoTooltip"
         [tooltipTemplate]="closeDialog"
         tooltipClass="tooltip-confirm-dialog"
      >
         <button #cancelButton style="min-width: 5em" kendoButton (click)="onCancel()">
            <div class="sam-button-text">
               {{ 'common.cancel' | translate }}
            </div>
         </button>

         <ng-template #closeDialog>
            <div (samwebOutsideClick)="onCloseCancel()">
               <samweb-confirm-dialog
                  [displayedText]="'common.confirmation.close_entry' | translate"
                  (confirm)="onCloseConfirm()"
                  (cancel)="onCloseCancel()"
               ></samweb-confirm-dialog>
            </div>
         </ng-template>
      </div>
   </div>
</div>
